import { create } from 'jss'
import { createGlobalStyle } from 'styled-components'
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles'

export const GlobalStyle = createGlobalStyle`
/* To make form scrollable (ex. UpdatePackFoorm) */
  form:not(.height-auto) {
    height: 100%;
  }
  .hidden {
    display: none;
  }
  .full-height {
    height: 100%;
  }
`

const styleNode = document.createComment('jss-insertion-point')
document.head.insertBefore(styleNode, document.head.firstChild)

export const generateClassName = createGenerateClassName()
export const jss = create({
  ...jssPreset(),
  insertionPoint: 'jss-insertion-point',
})
